import React from 'react'
import DimensionBadge from '../../common/dimension-badge'


const DimensionsPillList = ({
    dimensions = [],
}) => {

    //  We could have an array of ids, or an array of objects containing IDs.  

    dimensions = dimensions.map(d => typeof d === 'string' ? d : d.id)

    const renderDimension = (dimension, key) => {
        return (
            <DimensionBadge key={key} dimensionId={dimension} />
        )
    }

    return (
        <React.Fragment>
            {dimensions.map(renderDimension)}
        </React.Fragment>
    )
}

export default DimensionsPillList